var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-rate"},[_vm._l((_vm.rates),function(item,index){return [_c('span',{key:index,staticClass:"fa",class:{
        'fa-heart':_vm.value-1>=index,
        'fa-heart-o':_vm.value-1 <index
       }})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }